import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {MetaTagDefinitionData, MetaTagType} from "../../catalogue/meta-tag/meta-tag.data";

@Injectable()
export class OrderReadyQualifierEntityModel extends EntityModel<MetaTagDefinitionData> {

    constructor(injector: Injector) {
        super(injector, MetaTagDefinitionData);
    }

    override getResourceName(): string {
        return "meta-tag-definition";
    }

    override getResource(): string {
        return "order-ready-qualifier";
    }

    protected override onNewEntity(entityData: MetaTagDefinitionData): void {
        super.onNewEntity(entityData);
        entityData.type = MetaTagType.ORDER_READY_QUALIFIER;
    }
}
